import api from "./api";

export async function fetchQuizBatchAnalytics(params = {}) {
  const response = await api.get("/quiz/quiz-batch-analytics", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}
